import styles from './index.module.scss';
import Banner from './components/Banner';
import Stories from './components/Stories';
import Challenges from './components/Challenges';
import Contact from './components/Contact';
import Partner from './components/Partner';
import Sustainability from './components/Sustainability';
import getLocal from 'eco-design-reliance/getLocal';

export default function PowerForAll() {
    const { locale } = getLocal();
    return (
        <div className={`${styles.PowerForAll} GtmModuleData-section`}>
            <Banner />
            <Stories />
            {locale === 'global' && <Sustainability />}
            <Partner />
            <Challenges />
            <Contact />
        </div>
    );
}
